export const directoryFilesConstants = {
  GET_LIST_REQUEST: 'GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'GET_LIST_FAILURE',
};
